import styled from 'styled-components';

const InformativeSliderGallerySecondaryStyle = styled.div`
	--infoWrapPadding: var(--sp13x) var(--sp14x) var(--sp13x) var(--sp26x);
	--galleryWrapWidth: 49.4%;
	--infoNumberMarginBottom: var(--sp7x);
	--infoTitleMarginBottom: var(--sp7x);
	--infoDescriptionMarginBottom: var(--sp7x);
	--infoTipMarginRight: var(--sp2x);
	--imageProportion: 82.7%;

	--leftArrowMarginRight: var(--sp7x);

	--dotSizes: var(--sp1x);
	--paginationWrapRight: var(--sp8x);
	--learnMoreMarginTop: var(--sp5x);
	--sectionHeight: var(--sp130x);

	--arrowsWrapPositionLeft: var(--sp26x);
	--arrowsWrapPositionBottom: var(--sp13x);

	height: var(--sectionHeight);
	position: relative;
	display: flex;
	background-color: var(--secondaryColor4);

	.main-content {
		overflow: hidden;
	}

	.info-wrap {
		padding: var(--infoWrapPadding);
		width: calc(100% - var(--galleryWrapWidth));
		position: relative;
		overflow: hidden;

		.info-content {
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			padding: var(--infoWrapPadding);
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			opacity: 0;
			transition: opacity 0.5s;
			pointer-events: none;
			height: 100%;
			overflow: hidden;

			&.active {
				position: relative;
				opacity: 1;
				padding: unset;
				transition: opacity 0.5s 0.5s;
				pointer-events: all;
				overflow: hidden;
			}

			.info-number {
				margin-bottom: var(--infoNumberMarginBottom);
			}

			.info-title {
				margin-bottom: var(--infoTitleMarginBottom);
			}

			.info-description {
				margin-bottom: var(--infoDescriptionMarginBottom);
			}

			.learn-more {
				display: block;
				width: fit-content;
				margin-top: var(--learnMoreMarginTop);
				text-underline-offset: var(--sp0-5x);

				&.has-space {
					margin-left: calc(var(--h4) + var(--infoTipMarginRight));
				}
			}

			.tip-wrap {
				display: flex;

				.info-tip-icon {
					margin-right: var(--infoTipMarginRight);
				}
			}
		}
	}

	.arrows-wrap {
		position: absolute;
		display: flex;
		left: var(--arrowsWrapPositionLeft);
		bottom: var(--arrowsWrapPositionBottom);

		.left-arrow {
			height: fit-content;
			transform: rotate(180deg);
			margin-right: var(--leftArrowMarginRight);
		}

		.right-arrow {
			height: fit-content;
		}

		.left-arrow,
		.right-arrow {
			cursor: pointer;

			&.disable {
				pointer-events: none;
				opacity: 0.5;
			}
		}
	}

	.gallery-wrap {
		position: relative;
		overflow: hidden;
		width: var(--galleryWrapWidth);

		.slide-info-image {
			--imagePaddingTop: var(--imageProportion);

			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			width: 100%;
			height: 100%;
			transition: var(--trTime);
			pointer-events: none;

			&.next-slide {
				clip-path: inset(0 100% 0 0);
				overflow: hidden;
				z-index: 2;
				transition: var(--trTime);
			}

			&.prev-slide {
				clip-path: inset(0 0 0 100%);
				overflow: hidden;
				z-index: 2;
				transition: var(--trTime);
			}

			&.active {
				position: relative;
				pointer-events: all;
				clip-path: inset(0 0 0 0);
				transition: var(--trTime);
			}

			img {
				object-fit: cover;
			}
		}

		.pagination-wrap {
			display: flex;
			flex-direction: column;
			position: absolute;
			top: 50%;
			z-index: 10;
			right: var(--paginationWrapRight);
			transform: translateY(-50%);

			.dot {
				display: inline-block;
				width: var(--dotSizes);
				height: var(--dotSizes);
				background: var(--primaryColor3);
				border-radius: calc(var(--dotSizes) / 2);
				transition: var(--trTime);
				cursor: pointer;

				&.active {
					height: calc(2.5 * var(--dotSizes));
					cursor: none;
				}

				&:not(:last-child) {
					margin-bottom: var(--dotSizes);
				}
			}
		}
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXLMin}) {
		--infoWrapPadding: var(--sp10x) var(--sp11x) var(--sp10x) var(--sp20x);
		--infoNumberMarginBottom: var(--sp5x);
		--infoTitleMarginBottom: var(--sp5x);
		--infoDescriptionMarginBottom: var(--sp5x);
		--infoTipMarginRight: var(--sp2x);

		--leftArrowMarginRight: var(--sp5x);

		--paginationWrapRight: var(--sp6x);
		--learnMoreMarginTop: var(--sp3x);
		--sectionHeight: var(--sp102x);

		--arrowsWrapPositionLeft: var(--sp20x);
		--arrowsWrapPositionBottom: var(--sp10x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeLMin}) {
		--infoWrapPadding: var(--sp7x) var(--sp8x) var(--sp7x) var(--sp15x);
		--infoNumberMarginBottom: var(--sp4x);
		--infoTitleMarginBottom: var(--sp4x);
		--infoDescriptionMarginBottom: var(--sp4x);
		--infoTipMarginRight: var(--sp1-5x);

		--leftArrowMarginRight: var(--sp4x);

		--paginationWrapRight: var(--sp5x);
		--learnMoreMarginTop: var(--sp3x);
		--sectionHeight: var(--sp87x);

		--arrowsWrapPositionLeft: var(--sp15x);
		--arrowsWrapPositionBottom: var(--sp7x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeMMin}) {
		--infoWrapPadding: var(--sp7x) var(--sp8x) var(--sp7x) var(--sp15x);
		--infoNumberMarginBottom: var(--sp4x);
		--infoTitleMarginBottom: var(--sp4x);
		--infoDescriptionMarginBottom: var(--sp4x);
		--infoTipMarginRight: var(--sp1-5x);

		--leftArrowMarginRight: var(--sp4x);

		--paginationWrapRight: var(--sp5x);
		--learnMoreMarginTop: var(--sp3x);
		--sectionHeight: var(--sp84x);

		--arrowsWrapPositionLeft: var(--sp15x);
		--arrowsWrapPositionBottom: var(--sp7x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeSMin}) {
		--infoWrapPadding: var(--sp6x) var(--sp5x) var(--sp6x) var(--sp13x);
		--infoNumberMarginBottom: var(--sp4x);
		--infoTitleMarginBottom: var(--sp4x);
		--infoDescriptionMarginBottom: var(--sp4x);
		--infoTipMarginRight: var(--sp1-5x);

		--leftArrowMarginRight: var(--sp4x);

		--paginationWrapRight: var(--sp4x);
		--learnMoreMarginTop: var(--sp2x);
		--sectionHeight: var(--sp80x);

		--arrowsWrapPositionLeft: var(--sp13x);
		--arrowsWrapPositionBottom: var(--sp6x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXSMin}) {
		--infoWrapPadding: var(--sp6x) var(--sp8x);
		--infoNumberMarginBottom: var(--sp3x);
		--infoTitleMarginBottom: var(--sp3x);
		--infoDescriptionMarginBottom: var(--sp3x);
		--infoTipMarginRight: var(--sp1x);

		--leftArrowMarginRight: var(--sp4x);

		--paginationWrapRight: var(--sp4x);
		--galleryWrapWidth: 100%;
		--imageProportion: 67%;
		--learnMoreMarginTop: var(--sp2x);
		--sectionHeight: unset;

		--arrowsWrapPositionLeft: unset;
		--arrowsWrapPositionBottom: unset;

		flex-direction: column;

		.arrows-wrap {
			position: static;
			justify-content: flex-end;
			margin-top: var(--sp6x);
		}

		.info-wrap {
			width: 100%;
		}
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeMin}) {
		--infoWrapPadding: var(--sp5x) var(--sp8x);
		--infoNumberMarginBottom: var(--sp3x);
		--infoTitleMarginBottom: var(--sp3x);
		--infoDescriptionMarginBottom: var(--sp3x);
		--infoTipMarginRight: var(--sp1x);

		--leftArrowMarginRight: var(--sp4x);

		--paginationWrapRight: var(--sp4x);
		--galleryWrapWidth: 100%;
		--imageProportion: 67%;
		--learnMoreMarginTop: var(--sp2x);
		--sectionHeight: unset;

		--arrowsWrapPositionLeft: unset;
		--arrowsWrapPositionBottom: unset;

		flex-direction: column;

		.arrows-wrap {
			position: static;
			justify-content: flex-end;
			margin-top: var(--sp6x);
		}

		.info-wrap {
			width: 100%;
		}
	}

	@media (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
		--infoWrapPadding: var(--sp4x) var(--sp3x);
		--infoNumberMarginBottom: var(--sp3x);
		--infoTitleMarginBottom: var(--sp3x);
		--infoDescriptionMarginBottom: var(--sp3x);
		--infoTipMarginRight: var(--sp1x);

		--leftArrowMarginRight: var(--sp4x);

		--paginationWrapRight: var(--sp3x);
		--galleryWrapWidth: 100%;
		--imageProportion: 86.7%;
		--learnMoreMarginTop: var(--sp2x);
		--sectionHeight: unset;

		--arrowsWrapPositionLeft: unset;
		--arrowsWrapPositionBottom: unset;

		flex-direction: column;

		.arrows-wrap {
			position: static;
			justify-content: flex-end;
			margin-top: var(--sp5x);
		}

		.info-wrap {
			width: 100%;
		}
	}
`;

export default InformativeSliderGallerySecondaryStyle;
